<template>
  <span>
    <v-btn v-if="is_edit" icon color="grey" @click="open"><v-icon>mdi-pencil</v-icon></v-btn>
    <v-dialog width="600" v-model="dialog">
      <v-card>
        <v-card-title class="grey--text text-subtitle-1">
          {{ is_edit ? 'Modifica Specie' : 'Nuova Specie' }}
        </v-card-title>
        <v-card-text>

          <!-- Info base -->
          <div class="text-caption text-uppercase grey--text font-weight-medium mb-2">Info base</div>
          <v-row justify="center" class="mb-2">
            <v-col cols="4">
              <v-card
                class="portrait d-flex justify-center"
                :img="image_box"
                height="150"
                width="150"
                @click="$refs.input.click()"
              >
                <v-icon v-if="!file && !image_box">mdi-image</v-icon>
                <input
                  type="file"
                  style="display: none"
                  @change="onFileChange($event)"
                  ref="input"
                />
              </v-card>
            </v-col>
            <v-col cols="8">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="nome"
                    outlined
                    label="Nome"
                    prepend-inner-icon="mdi-leaf"
                    hide-details
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="nome_sc"
                    outlined
                    label="Nome Scientifico"
                    prepend-inner-icon="mdi-flask-empty"
                    hide-details
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-alert v-if="is_duplicato" type="warning" dense text class="mb-3">
            Esiste già una specie con questo nome
          </v-alert>

          <v-divider class="mb-4" />

          <!-- Caratteristiche agronomiche -->
          <div class="text-caption text-uppercase grey--text font-weight-medium mb-2">Caratteristiche agronomiche</div>
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="esposizione"
                :items="esposizone_list"
                item-text="text"
                item-value="value"
                label="Esposizione"
                prepend-inner-icon="mdi-umbrella-beach"
                outlined
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="richiesta_idr"
                :items="richiesta_idr_list"
                item-text="text"
                item-value="value"
                label="Richiesta Idrica"
                prepend-inner-icon="mdi-watering-can"
                hide-details
                outlined
              />
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="manutenzione"
                :items="manutenzione_list"
                item-text="text"
                item-value="value"
                label="Manutenzione"
                prepend-inner-icon="mdi-heart"
                hide-details
                outlined
              />
            </v-col>
            <v-col cols="6">
              <v-switch v-model="resistenza" inset label="Resistente al Gelo" hide-details />
            </v-col>
          </v-row>

          <v-divider class="mb-4 mt-2" />

          <!-- Coltivazione -->
          <div class="text-caption text-uppercase grey--text font-weight-medium mb-2">Coltivazione</div>
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="propagazione"
                :items="propagazione_list"
                item-text="text"
                item-value="value"
                label="Tipo Propagazione"
                prepend-inner-icon="mdi-seed"
                hide-details
                outlined
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model.number="tempo_vendita"
                type="number"
                min="0"
                outlined
                label="Settimane Trapianto → Vendita"
                prepend-inner-icon="mdi-calendar-clock"
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <div class="text-caption grey--text mb-2">Periodo di Fioritura</div>
              <MonthPicker v-model="months" />
            </v-col>
          </v-row>

        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text color="grey" @click="close()">Annulla</v-btn>
          <v-btn
            outlined
            color="green"
            :loading="loading_salva"
            :disabled="!nome || !nome_sc || is_duplicato"
            @click="invia_specie()"
          ><v-icon class="mr-2">mdi-content-save</v-icon>Salva</v-btn>
        </v-card-actions>
      </v-card>

      <v-snackbar v-model="snackbar_errore" color="error" timeout="4000">
        Errore durante il salvataggio
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar_errore = false">Chiudi</v-btn>
        </template>
      </v-snackbar>
    </v-dialog>
  </span>
</template>

<script>
import MonthPicker from "./specie_form_fields.vue";

const defaultData = () => ({
  nome: null,
  nome_sc: null,
  esposizione: 0,
  richiesta_idr: 0,
  manutenzione: 0,
  months: [],
  resistenza: false,
  propagazione: null,
  tempo_vendita: null,
  loading_salva: false,
  file: null,
  image_box: null,
  snackbar_errore: false,
});

export default {
  components: { MonthPicker },
  props: {
    specie: { type: Object, default: null },
  },
  data() {
    return {
      dialog: false,
      esposizone_list: [
        { value: 0, text: "Non Definito" },
        { value: 1, text: "Ombra" },
        { value: 2, text: "Mezz'ombra" },
        { value: 3, text: "Pieno Sole" },
      ],
      richiesta_idr_list: [
        { value: 0, text: "Non Definito" },
        { value: 1, text: "Bassa" },
        { value: 2, text: "Media" },
        { value: 3, text: "Alta" },
      ],
      manutenzione_list: [
        { value: 0, text: "Non Definito" },
        { value: 1, text: "Bassa" },
        { value: 2, text: "Media" },
        { value: 3, text: "Alta" },
      ],
      propagazione_list: [
        { value: 1, text: "Seme" },
        { value: 2, text: "Talea" },
      ],
      ...defaultData(),
    };
  },
  computed: {
    is_edit() {
      return !!this.specie;
    },
    is_duplicato() {
      if (!this.nome) return false;
      const nome_lower = this.nome.trim().toLowerCase();
      return this.$store.getters.get_specie.some(
        (s) =>
          s.nome.trim().toLowerCase() === nome_lower &&
          (!this.is_edit || s.id !== this.specie.id)
      );
    },
  },
  methods: {
    open() {
      if (this.is_edit) {
        Object.assign(this.$data, {
          ...defaultData(),
          nome: this.specie.nome,
          nome_sc: this.specie.nome_sc,
          esposizione: this.specie.exposition,
          richiesta_idr: this.specie.water_request,
          resistenza: this.specie.frost_resist,
          manutenzione: this.specie.manutenzione,
          propagazione: this.specie.propagazione,
          tempo_vendita: this.specie.tempo_vendita ?? null,
          months: this.specie.mesi_fioritura ? [...this.specie.mesi_fioritura] : [],
          image_box: `${process.env.VUE_APP_API_ROOT}/specie/${this.specie.id}/img?md5=${this.specie.img_md5}`,
        });
      } else {
        Object.assign(this.$data, defaultData());
      }
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    invia_specie() {
      this.loading_salva = true;
      const payload = {
        nome: this.nome,
        nome_sc: this.nome_sc,
        exposition: this.esposizione,
        water_request: this.richiesta_idr,
        frost_resist: this.resistenza,
        manutenzione: this.manutenzione,
        mesi_fioritura: this.months,
        propagazione: this.propagazione,
        tempo_vendita: this.tempo_vendita,
      };
      const action = this.is_edit
        ? this.$store.dispatch("edit_specie", { id_specie: this.specie.id, ...payload })
        : this.$store.dispatch("create_new_specie", payload);

      action
        .then((res) => {
          if (this.file) {
            const formData = new FormData();
            formData.append("file", this.file);
            return this.$store.dispatch("nuova_img_specie", {
              id_specie: res.id,
              formData,
            });
          }
        })
        .catch(() => {
          this.snackbar_errore = true;
        })
        .finally(() => {
          this.loading_salva = false;
          this.close();
        });
    },
    onFileChange(e) {
      this.file = e.target.files[0];
      this.createImage(this.file);
    },
    createImage(file) {
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        this.image_box = reader.result;
      }, false);
      reader.readAsDataURL(file);
    },
  },
};
</script>
